import { styled } from '@mui/material'
import { Flex, FlexBetween, FlexCenter } from 'styles'

export const Mask = styled(Flex)`
  position: fixed;
  top: 0;
  padding-top: 64px;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${(props) => props.theme.color.bgMask};

  z-index: 99;
  backdrop-filter: blur(5px);

  ${(props) => props.theme.breakpoints.down('md')} {
    align-items: flex-end;
  }
`
export const Panel = styled(Flex)`
  flex-direction: column;
  width: 256px;
  height: 100%;
  background: ${(props) => props.theme.color.bg};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  overflow-y: hidden;
  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
    max-height: 514px;
    // bottom: 0;
  }
`
export const SymbolList = styled(Flex)`
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
`
export const MobileTile = styled(FlexBetween)`
  height: 68px;
  padding: 22px;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  display: none;
  color: ${(props) => props.theme.color.text100};
  border-bottom: 1px solid ${(props) => props.theme.color.bgGray};
  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
  }
  .iconfont {
    color: ${(props) => props.theme.color.text40};
  }
`

export const FilterInput = styled('div')`
  display: flex;
  width: 100%;
  padding: 10px 10px 0;
  position: relative;
  ${(props) => props.theme.breakpoints.down('md')} {
    padding: 16px 22px;
  }
`
export const Input = styled('input')`
  flex: 1;
  height: 36px;
  font-size: 16px;
  padding: 0 0 0 36px;
  border: 1px solid ${(props) => props.theme.color.text10};
  box-sizing: border-box;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  background-color: ${(props) => props.theme.color.bgGray};
  color: ${(props) => props.theme.color.text90};
  outline: none;
  &::placeholder {
    color: ${(props) => props.theme.color.text40};
  }
  &:focus {
    border: 1px solid ${(props) => props.theme.color.primary30};
  }
`
export const FilterInputContent = styled(Flex)`
  position: relative;
  width: 100%;
  height: 100%;
`
export const Icon = styled(FlexCenter)`
  width: 36px;
  height: 36px;
  position: absolute;
  left: 0;
  top: 0;
  .iconfont {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    color: ${(props) => props.theme.color.text40};
  }
`
export const Label = styled(FlexBetween)`
  color: #767e9c;
  font-size: 12px;
  line-height: 12px;
  padding: 8px;
  margin: 4px 0 0;
  border-bottom: 1px solid ${(props) => props.theme.color.text10};
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
export const MarketItemWrap = styled(FlexCenter)`
  font-size: 12px;
  line-height: 16px;
  padding: 8px;
  border-bottom: 1px solid ${(props) => props.theme.color.text10};

  &:hover {
    background: ${(props) => props.theme.color.bgGray};
    cursor: pointer;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    padding: 8px 22px;
  }
`
export const MarketIcon = styled('img')`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 6px;
`
export const MarketName = styled('b')`
  font-size: 14px;
  color: ${(props) => props.theme.color.text80};
  font-weight: 600;
`
export const MarketPrice = styled('b')`
  font-weight: 600;
  color: ${(props) => props.theme.color.text80};
`
export const MarketRange = styled('div')`
  color: #419e6a;
`
export const MarketIconWrap = styled('div')`
  position: relative;
  svg {
    position: absolute;
    top: -4px;
    right: 2px;
  }
`
